import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToHashLocation(content: unknown) {
  const { hash } = useLocation();
  const { memoizedContent, memoizedHash } = useMemo(
    () => ({
      memoizedContent: content,
      memoizedHash: hash,
    }),
    [content, hash]
  );
  useEffect(() => {
    if (memoizedHash) {
      document
        .getElementById(memoizedHash.slice(1))
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [memoizedContent, memoizedHash]);
}
